<template
  ><v-container>
    <v-row class="align-center mb-2" >
      <v-col class="d-flex justify-end">
        <v-btn color="primary" @click="$refs.commentDialog.showDialog(sourceType, sourceGuid)">
          <v-icon left>mdi-plus</v-icon>
          {{ $t("portfolio.comment.add") }}
        </v-btn>
      </v-col>
    </v-row>

    <Comments
      showNoData
      :showTitle="false"
      ref="comments"
      :sourceType="sourceType"
      :sourceGuid="sourceGuid"
      v-model="comments"
      @input="$forceUpdate()"
    />

    <CommentsDialog
      ref="commentDialog"
      @add="addCommentHandler"
      :sourceType="sourceType"
    /> </v-container
></template>

<script>
import Comments from "../../../../components/portfolio/comments/comments.vue";
import CommentsDialog from "../../../../components/portfolio/comments/commentsDialog.vue";

export default {
  components: {
    CommentsDialog,
    Comments
  },
  data() {
    return {
      comments: [],
      loading: false
    };
  },
  props: {
    sourceGuid: {
      type: String,
      required: true
    },
    sourceType: {
      type: String,
      required: true
    }
  },
  created() {
    this.getComments();
  },
  methods: {
    addCommentHandler(comment) {
      this.$refs.comments.addComment(comment);
    },
    async getComments() {
      this.loading = true;
      await this.axios
        .get("Comment/Get", {
          params: {
            sourceGuid: this.sourceGuid,
            sourceType: this.sourceType
          }
        })
        .then(res => {
          this.comments = res.data.data;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
